import PropTypes from 'prop-types';

import assert from 'assert';

import objectToGetParams from './utils/objectToGetParams';
import createShareButton from './utils/createShareButton';

function tumblrLink(url, _ref) {
  var title = _ref.title,
      caption = _ref.caption,
      tags = _ref.tags,
      posttype = _ref.posttype;

  assert(url, 'tumblr.url');

  return 'https://www.tumblr.com/widgets/share/tool' + objectToGetParams({
    canonicalUrl: url,
    title: title,
    caption: caption,
    tags: tags,
    posttype: posttype
  });
}

var TumblrShareButton = createShareButton('tumblr', tumblrLink, function (props) {
  return {
    title: props.title,
    tags: props.tags.join(','),
    caption: props.caption,
    posttype: props.posttype
  };
}, {
  title: PropTypes.string,
  caption: PropTypes.string,
  posttype: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string)
}, {
  tags: [],
  posttype: 'link',
  windowWidth: 660,
  windowHeight: 460
});

export default TumblrShareButton;


//////////////////
// WEBPACK FOOTER
// ./~/react-share/es/TumblrShareButton.js
// module id = 798
// module chunks = 0